import { useState } from "react";

export const useWidgetLoading = () => {
  const [isLoading, setIsLoading] = useState(false);

  // Function to show loading spinner
  const showLoading = () => setIsLoading(true);

  // Function to hide loading spinner
  const hideLoading = () => setIsLoading(false);

  return { isLoading, showLoading, hideLoading };
};
